import { render, staticRenderFns } from "./SemenQuaratinetwoFields.vue?vue&type=template&id=2f98affa&scoped=true&"
import script from "./SemenQuaratinetwoFields.vue?vue&type=script&lang=js&"
export * from "./SemenQuaratinetwoFields.vue?vue&type=script&lang=js&"
import style0 from "./SemenQuaratinetwoFields.vue?vue&type=style&index=0&id=2f98affa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f98affa",
  null
  
)

export default component.exports